/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoModelsPreview
 */
export interface FusionMelcoModelsPreview {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsPreview
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsPreview
     */
    url?: string | null;
}

export function FusionMelcoModelsPreviewFromJSON(json: any): FusionMelcoModelsPreview {
    return FusionMelcoModelsPreviewFromJSONTyped(json, false);
}

export function FusionMelcoModelsPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function FusionMelcoModelsPreviewToJSON(value?: FusionMelcoModelsPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}


